export default [
  { label: 'Logged In', value: 'loggedin' },
  { label: 'Classmates', value: 'classmates' },
  { label: 'Private', value: 'private' }
]
